/**
 * Helper functions for door data display and formatting
 */

/**
 * Formatiert eine Türnummer MIT führenden Nullen (3-stellig)
 * Bug #10/#32/#23: Konsistente Türnummern-Anzeige
 *
 * Beispiele:
 * - "1" → "001"
 * - "50" → "050"
 * - "100" → "100"
 * - "TEST-B7" → "TEST-B7" (alphanumerisch bleibt unverändert)
 * - "T001" → "T001" (mit Präfix bleibt unverändert)
 *
 * @param doorNumber - Die zu formatierende Türnummer
 * @returns Die formatierte Türnummer mit führenden Nullen (bei rein numerischen Werten)
 */
export function formatDoorNumber(doorNumber: string | null | undefined): string {
  if (!doorNumber) return '';

  const trimmed = doorNumber.trim();

  // Prüfe ob es eine reine Zahl ist (ggf. mit führenden Nullen)
  if (/^\d+$/.test(trimmed)) {
    // Rein numerisch: auf 3 Stellen mit führenden Nullen auffüllen
    const num = parseInt(trimmed, 10);
    return num.toString().padStart(3, '0');
  }

  // Alphanumerisch oder mit Präfix: Original zurückgeben
  return trimmed;
}
